import type { PropsWithChildren } from "react";

import styles from "./Table.module.css";

// The wrapper scrolls the table sideways when it is wider than the screen
export const Table = ({ children }: PropsWithChildren) => {
  return (
    <div className="overflow-x-auto">
      <table className={styles.adminTable}>{children}</table>
    </div>
  );
};
